import type { NextPage, GetStaticProps, GetStaticPropsContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import PageNotFound from '~/page-not-found/pages/PageNotFound.page'

const Page404: NextPage = () => {
  return <PageNotFound statusCode={404} />
}

const PAGE_404_NAMESPACES = ['notFound', 'footer', 'dashboard', 'chatAi', 'subscription']

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale as string, PAGE_404_NAMESPACES)),
  },
})

export default Page404
